module.exports = __webpack_public_path__ + "img/DE02873.e92ef21a.png";